import * as Types from '../../graphql/generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RegenerateCollectionDraftMutationVariables = Types.Exact<{
  generation_run_id: Types.Scalars['UUID'];
  invoice_collection_id: Types.Scalars['ID'];
}>;


export type RegenerateCollectionDraftMutation = { __typename?: 'Mutation', regenerateCollectionDraft: { __typename?: 'InvoiceCollectionDraftRegeneration', id: string, status: Types.InvoiceRunStatus, enqueued_at: string } };


export const RegenerateCollectionDraftDocument = gql`
    mutation RegenerateCollectionDraft($generation_run_id: UUID!, $invoice_collection_id: ID!) {
  regenerateCollectionDraft(
    generation_run_id: $generation_run_id
    invoice_collection_id: $invoice_collection_id
  ) {
    id
    status
    enqueued_at
  }
}
    `;
export type RegenerateCollectionDraftMutationFn = Apollo.MutationFunction<RegenerateCollectionDraftMutation, RegenerateCollectionDraftMutationVariables>;

/**
 * __useRegenerateCollectionDraftMutation__
 *
 * To run a mutation, you first call `useRegenerateCollectionDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateCollectionDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateCollectionDraftMutation, { data, loading, error }] = useRegenerateCollectionDraftMutation({
 *   variables: {
 *      generation_run_id: // value for 'generation_run_id'
 *      invoice_collection_id: // value for 'invoice_collection_id'
 *   },
 * });
 */
export function useRegenerateCollectionDraftMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateCollectionDraftMutation, RegenerateCollectionDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateCollectionDraftMutation, RegenerateCollectionDraftMutationVariables>(RegenerateCollectionDraftDocument, options);
      }
export type RegenerateCollectionDraftMutationHookResult = ReturnType<typeof useRegenerateCollectionDraftMutation>;
export type RegenerateCollectionDraftMutationResult = Apollo.MutationResult<RegenerateCollectionDraftMutation>;
export type RegenerateCollectionDraftMutationOptions = Apollo.BaseMutationOptions<RegenerateCollectionDraftMutation, RegenerateCollectionDraftMutationVariables>;